<template>
  <div>
    <Modal
      title="分配应用"
      v-model="modalVisible"
      :mask-closable="false"
      @on-cancel="cancelModal"
      width="1000"
    >
      <Checkbox-group prop="appIdList" v-model="formData.appIdList">
        <Row>
          <Col :span="6" v-for="item in appList" :key="item.appId">
            <Checkbox :label="item.appId">
              <span>{{ item.appName }}</span>
            </Checkbox>
          </Col>
        </Row>
      </Checkbox-group>
      <span slot="footer" class="dialog-footer">
        <Button @click="cancelModal">取 消</Button>
        <Button type="primary" @click="submit">确 定</Button>
      </span>
      <Spin size="large" fix v-if="loading"></Spin>
    </Modal>
  </div>
</template>

<script>
import modalMixins from '@/mixins/modalMixins';
import { getAppInAuthUserList, saveAppInAuthUser } from '@/api/userManage';
export default {
  mixins: [modalMixins],
  data() {
    return {
      loading: false,
      formData: {
        appIdList: []
      },
      appList: []
    };
  },
  methods: {
    modalInit() {
      this.getData(this.userId);
    },
    async submit() {
      this.loading = true;
      const data = this.getSubmitData({ ...this.formData });
      const res = await saveAppInAuthUser(data);
      this.loading = false;
      const { code } = res.data;
      if (code === 200) {
        this.cancelModal();
      }
    },
    // 获取提交的数据
    getSubmitData(formData) {
      const obj = { ...formData };
      obj.userId = this.userId;
      return obj;
    },
    async getData (userId) {
      this.loading = true;
      const res = await getAppInAuthUserList({ userId });
      this.loading = false;
      const { code, data } = res.data;
      if (code === 200) {
        this.formData.appIdList = data.filter(i => i.checked).map(item => item.appId);
        this.appList = [...data];
      }
    }
  },
  props: {
    userId: String
  },
  created() {
    this.modalInit();
  }
};
</script>

<style></style>
